import { Heart, MessageCircle, Coins, Gift, Bell, Home, Users, Gamepad2, User } from "lucide-react";

const POSTS = [
  { name: "Lena", color: "from-amber-300 to-rose-400", text: "Unser erstes Treffen mit der Community war mega! 💕", likes: 128, comments: 24, img: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=600&q=70" },
  { name: "Tom", color: "from-sky-300 to-fuchsia-400", text: "Gerade 250 Punkte geknackt – die Autogrammkarte gehört mir 🎉", likes: 86, comments: 12 },
];

const MiniPost = ({ p }) => (
  <div className="bg-white rounded-2xl p-3 border border-pink-100 space-y-2 shadow-sm">
    <div className="flex items-center gap-2">
      <span className={`w-8 h-8 rounded-full bg-gradient-to-br ${p.color} text-white text-xs font-bold flex items-center justify-center`}>{p.name[0]}</span>
      <div className="leading-tight"><p className="text-xs font-bold">{p.name}</p><p className="text-[10px] text-slate-400">vor 5 Min.</p></div>
    </div>
    <p className="text-xs text-slate-700">{p.text}</p>
    {p.img && <img src={p.img} alt="" className="w-full h-28 object-cover rounded-xl" loading="lazy" />}
    <div className="flex items-center gap-4 text-[11px] text-slate-500 font-semibold">
      <span className="flex items-center gap-1 text-rose-500"><Heart className="w-3.5 h-3.5 fill-rose-500" /> {p.likes}</span>
      <span className="flex items-center gap-1"><MessageCircle className="w-3.5 h-3.5" /> {p.comments}</span>
    </div>
  </div>
);

export const PhoneMockup = ({ reward }) => (
  <div className="relative mx-auto w-[280px] sm:w-[310px]" data-testid="hero-mockup">
    <div className="absolute -inset-8 bg-gradient-to-br from-rose-400/30 via-pink-400/30 to-fuchsia-400/30 blur-3xl rounded-full" />
    <div className="relative rounded-[2.5rem] bg-slate-900 p-2.5 shadow-2xl shadow-rose-300/50 rotate-[2deg] hover:rotate-0 transition-transform duration-700">
      <div className="rounded-[2rem] bg-[#FFF5F7] overflow-hidden h-[540px] flex flex-col">
        <div className="px-4 pt-4 pb-2 flex items-center justify-between bg-white/90">
          <span className="font-display font-extrabold text-sm">itz<span className="text-rose-500">Play</span></span>
          <span className="flex items-center gap-1 px-2 py-0.5 rounded-full bg-amber-50 border border-amber-200 text-amber-700 text-[11px] font-bold"><Coins className="w-3 h-3" /> 1.240</span>
        </div>
        <div className="flex-1 overflow-hidden p-3 space-y-2.5">
          <div className="rounded-2xl p-3 text-white bg-gradient-to-r from-rose-500 via-pink-500 to-fuchsia-500 shadow-md">
            <p className="text-[10px] uppercase font-bold tracking-wider opacity-90 flex items-center gap-1"><Gift className="w-3 h-3" /> Nächstes Geschenk</p>
            <p className="text-sm font-bold truncate">{reward?.title || "Signierte Autogrammkarte"}</p>
            <div className="mt-2 h-1.5 rounded-full bg-white/30"><div className="h-full w-3/4 rounded-full bg-white" /></div>
          </div>
          {POSTS.map((p) => <MiniPost key={p.name} p={p} />)}
        </div>
        <div className="grid grid-cols-5 py-2 bg-white/95 border-t border-pink-100 text-slate-400">
          {[Home, Users, Gamepad2, Bell, User].map((I, i) => <I key={i} className={`w-5 h-5 mx-auto ${i === 0 ? "text-rose-500" : ""}`} />)}
        </div>
      </div>
    </div>
    <div className="absolute -left-12 top-[17rem] hidden sm:flex items-center gap-2 px-3 py-2 rounded-2xl bg-white shadow-xl border border-pink-100 animate-[float_6s_ease-in-out_infinite]">
      <span className="w-8 h-8 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center"><Coins className="w-4 h-4" /></span>
      <div className="leading-tight"><p className="text-xs font-bold">+10 Punkte</p><p className="text-[10px] text-slate-400">Beitrag geliked</p></div>
    </div>
    <div className="absolute -right-8 bottom-28 hidden sm:flex items-center gap-2 px-3 py-2 rounded-2xl bg-white shadow-xl border border-pink-100 animate-[float_7s_ease-in-out_infinite_1s]">
      <span className="w-8 h-8 rounded-full bg-rose-100 text-rose-500 flex items-center justify-center"><Heart className="w-4 h-4 fill-rose-500" /></span>
      <div className="leading-tight"><p className="text-xs font-bold">Neue Freundin</p><p className="text-[10px] text-slate-400">Anfrage angenommen</p></div>
    </div>
  </div>
);
